/**
 * Dedupes and sorts an array of IDs so that equivalent requests (same set of
 * IDs, different order) produce the same result.
 *
 * This needs to run in two places for two different reasons:
 * - Client-side, before building a request URL: so that different callers
 *   requesting the same logical set of IDs produce byte-identical URLs. This
 *   is what actually matters for Akamai's edge cache, which keys off the raw
 *   request URL/query string as sent by the browser -- it can't benefit from
 *   any canonicalization that happens later, on the origin server.
 * - Server-side, before using the IDs as arguments to a cached function (see
 *   `getFurtherResources.ts`): so that Next.js's `unstable_cache` (keyed off
 *   its wrapped function's arguments) produces a cache hit regardless of the
 *   order the caller happened to pass IDs in.
 */
export function canonicalizeIds(ids: string[]): string[] {
  return Array.from(new Set(ids)).sort();
}
